import React, { useState, useEffect } from "react";
import ExxonWhite from "../../assets/Images/exxon-white.png";
import { addDoc, collection } from "firebase/firestore/lite";
import { getFirestore } from "firebase/firestore/lite";
import firebaseApp from "../firebase.config";
import { IoMdSend } from "react-icons/io";

const db = getFirestore(firebaseApp);

function ChatBot({ autoOpen = false }) {
  const [step, setStep] = useState(1);
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showChatbox, setShowChatbox] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [emailProvided, setEmailProvided] = useState(false);
  const showChat = () => {
    setShowChatbox(true);
  };

  // Initial bot messages
useEffect(() => {
  // Only run if chatbox is open and messages haven't been sent yet
  if (!showChatbox) return;


  const t1 = setTimeout(() => {
    setMessages((prev) => [
      ...prev,
      {
        content: ( 
          <div className="flex items-center gap-2">
            {/* <img src={ExxonIconc} className="w-8 h-8" alt="" /> */}
            <p>Welcome! Do you need to expand your IT team?</p>
          </div>
        ),
        isUserMessage: false,
      },
    ]);
    setLoading(true);

    const t2 = setTimeout(() => {
      setLoading(false);
      setMessages((prev) => [
        ...prev,
        {
          content: (
            <button  className="text-white px-3 py-1 rounded">
              Yes, please
            </button>
          ),
          isUserMessage: true,
        },
      ]);
      setLoading(true);

      const t3 = setTimeout(() => {
        setLoading(false);
        setMessages((prev) => [
          ...prev,
          {
            content: (
              <div className="flex items-center gap-2">
                {/* <img src={ExxonIconc} className="w-8 h-8" alt="" /> */}
                <p>Can you give me your Email address?</p>
              </div>
            ),
            isUserMessage: false,
          },
        ]);
      }, 3000);

      return () => clearTimeout(t3);
    },500);

    return () => clearTimeout(t2);
  });

  return () => clearTimeout(t1);
}, [showChatbox]);

  // Auto scroll
  useEffect(() => {
    const chat = document.getElementById("chat");
    if (chat) {
      chat.scrollTop = chat.scrollHeight;
    }
  }, [messages]);

  function sendMessage() {
    if (userInput.trim() === "") return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(userInput)) {
      alert("Invalid email address");
      return;
    }

    const emailRef = collection(db, "ExxonchatbotEmail");
    addDoc(emailRef, { userEmail: userInput });

    setMessages((prev) => [
      ...prev,
      { content: userInput, isUserMessage: true },
      {
        content: (
          <div className="flex items-center gap-2">
            {/* <img src={ExxonIconc} className="w-8 h-8" alt="" /> */}
            <p>
              Thank you! You'll receive an email notification shortly.
            </p>
          </div>
        ),
        isUserMessage: false,
      },
    ]);

    setUserInput("");
    setEmailProvided(true);
    setStep(step + 1);
  }

  useEffect(() => {
  if (autoOpen) {
    const timer = setTimeout(() => {
      setIsOpen(true);      // opens the modal
      // setShowChatbox(true); // also shows the chat content
    }, 1000); // delay in milliseconds
    return () => clearTimeout(timer);
  }
}, [autoOpen]);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-4 right-4 w-12 h-12 rounded-full bg-cyan-500 hover:bg-cyan-800 text-white flex items-center justify-center z-50"
      >
        <span>
          <i
            className="fa-regular fa-message fa-base"
            style={{ color: "#fff" }}
          ></i>
        </span>
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0  flex items-end justify-end z-50">
          <div className="w-[350px] h-[70%] sm:h-[450px] rounded-xl shadow-lg m-4 flex flex-col animate-slideIn">
            
            {/* Header */}
            <div className="flex justify-between items-center  bg-[#120e38]  p-3 rounded-t-xl">
              <img src={ExxonWhite} className="w-32" alt="logo" />
              <button
                onClick={() => setIsOpen(false)}
                className="text-white text-xl"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="flex-1 flex flex-col overflow-hidden bg-[#f1f1f1]">

              {/* Welcome */}
              {step === 1 && !showChatbox && (
                <div className="flex flex-col h-full justify-between items-start overflow-y-auto">
                 

                  <div className="p-4  space-y-2">
                     <h4 className="sm:text-lg font-semibold">
                    Welcome ! Do you need to expand and empower your IT team?
                  </h4>

                  <p className="text-sm mt-2 mb-4">
                    Get to know our expert inhouse developers, who power Exxon Info
                IT Staff Augmentation services, their skills, and what makes
                them valuable members of our team.
                  </p>

                    <button
                      onClick={showChat}
                      className="w-full bg-[#147fad] transform hover:scale-[0.98] transition-all duration-300 hover:bg-[#0f5f7b] text-white p-2 rounded"
                    >
                      Yes, please
                    </button>

                    <button
                      onClick={() => setIsOpen(false)}
                      className="w-full bg-gray-200 p-2 rounded transform hover:scale-[0.98] transition-all duration-300"
                    >
                      No, thanks
                    </button>

                 
                  </div>
                     <p className="text-xs mt-auto border-t px-4 py-3 border-gray-300">
                     By chatting with our bot, you agree to the Terms of Use and
                   Global Privacy Policy.
                    </p>
                </div>
              )}

              {/* Chat */}
              {showChatbox && (
                <>
                  {/* Messages */}
                  <div
                    id="chat"
                    className="flex flex-col overflow-y-auto p-3 space-y-2 max-w-[100%] "
                  >
                    {messages.map((msg, i) => (
                      <div
  key={i}
  className={`p-2  rounded mb-2 break-words sm:text-base text-sm inline-block ${
    msg.isUserMessage
      ? "bg-[#147fad] text-white ml-auto text-right max-w-[50%]" // user msg -> right
      : "bg-white text-black mr-auto text-left max-w-[70%]" // bot msg -> left
  }`}
>
  {msg.content}
</div>
                    ))}

                    {loading && (
                      <div className="text-sm text-gray-500">Typing...</div>
                    )}
                  </div>

                  {/* Input */}
                  {!emailProvided && (
                    <div className="flex mt-auto p-2 bg-white">
                      <input
                        type="text"
                        placeholder="Your business email..."
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        className="flex-1 text-[15px] rounded-sm  p-2  outline-none"
                      />
                      <button
                        onClick={sendMessage}
                        className="bg text-gray-600 px-2"
                      >
                        <IoMdSend size={24} />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Tailwind Animation */}
      <style>
        {`
          @keyframes slideIn {
            from { transform: translateX(50%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          .animate-slideIn {
            animation: slideIn 0.4s ease-out;
          }
        `}
      </style>
    </>
  );
}

export default ChatBot;